import moment, { Moment } from "moment";
import { getDateFormat, getTimeFormat } from "./dateTimeFormatting";

export default function getDeliveryWindow(
  timeSlotFrom: string,
  timeSlotTo: string
) {
  const dateFormat = getDateFormat();
  const timeFormat = getTimeFormat();
  
  const fromDate = moment(timeSlotFrom).utc().local().calendar(null, {
    lastDay: "[Yesterday]",
    sameDay: "[Today]",
    nextDay: "[Tomorrow]",
    lastWeek: "[Last] ddd",
    nextWeek: "dddd",
    sameElse: dateFormat,
  });
  const toDate = moment(timeSlotTo).utc().local().calendar(null, {
    lastDay: "[Yesterday]",
    sameDay: "[Today]",
    nextDay: "[Tomorrow]",
    lastWeek: "[Last] ddd",
    nextWeek: "dddd",
    sameElse: dateFormat,
  });
  const fromTime = moment.utc(timeSlotFrom).local().format(timeFormat);
  const toTime = moment.utc(timeSlotTo).local().format(timeFormat);

  if (fromDate === toDate) {
    return fromDate + ", " + fromTime + " - " + toTime;
  }
}

export function getDeliveryDate(date: Date | Moment | string) {
  const dateFormat = getDateFormat();
  const timeFormat = getTimeFormat();
  
  const dateText = moment(date).utc().local().calendar(null, {
    lastDay: "[Yesterday]",
    sameDay: "[Today]",
    nextDay: "[Tomorrow]",
    lastWeek: "[Last] ddd",
    nextWeek: "dddd",
    sameElse: dateFormat,
  });
  const timeText = moment.utc(date).local().format(timeFormat);
  return dateText + ", " + timeText;
}
